import {
    IBaseEnhance,
    IColorEnhance,
    IHslEnhance,
    ILightEnhance,
    IParticularsEnhance,
    IPosterizeEnhance,
} from './types';

// 效果系数
export const adapterConfig = {
    particulars: {
        // "锐化倍数": 1.5,
        sharpen: 1.5,
        // "清晰度倍数": 0.8,
        structure: 0.8,
        // "暗角倍数": 1.3,
        vignette: 1.3,
        // "颗粒倍数": 1.5,
        particle: 1.5,
        // "色散倍数": 2.5,
        dispersion: 2.5,
    },
    light: {
        // "智能补光倍数": 1.5,
        smartLightAlpha: 1.5,
        // "亮度倍数": 1.0,
        brightness: 1,
        // "对比度倍数": 2.0,
        contrast: 2.0,
        // "高光倍数": 1.5,
        highlight: 1.5,
        // "暗部改善倍数": 1.5,
        shadow: 1.5,
        // "褪色倍数": 1.5,
        fade: 1.5,
    },
    color: {
        // "饱和度倍数": 1.2,
        saturation: 1.2,
        // "色温倍数": 1.2,
        temperature: 1.2,
        // "色调倍数": 1.2,
        tinge: 1.2,
        // "HSL红色倍数": 1.5,
        // "HSL橙色倍数": 1.5,
        // "HSL黄色倍数": 1.5,
        // "HSL绿色倍数": 1.5,
        // "HSL蓝色倍数": 1.5,
        // "HSL紫色倍数": 1.5
        hsl_hue: [1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5],
        hsl_saturation: [1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5],
        hsl_light: [1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5],
        // "色调分离高光红色倍数": 1.2,
        // "色调分离高光橙色倍数": 1.2,
        // "色调分离高光黄色倍数": 1.2,
        // "色调分离高光绿色倍数": 1.2,
        // "色调分离高光蓝色倍数": 1.2,
        // "色调分离高光紫色倍数": 1.2,
        posterize_light: 1.2,
        // posterizelightcolor: [1.2, 1.2, 1.2, 1.2, 1.2, 1.2],
        // "色调分离阴影红色倍数": 1.2,
        // "色调分离阴影橙色倍数": 1.2,
        // "色调分离阴影黄色倍数": 1.2,
        // "色调分离阴影绿色倍数": 1.2,
        // "色调分离阴影蓝色倍数": 1.2,
        // "色调分离阴影紫色倍数": 1.2,
        posterize_shadow: 1.2,
        // posterize_shadow_color: [1.2, 1.2, 1.2, 1.2, 1.2, 1.2],
    },
    hslPickColors: [1, 1, 1],
    pickColors: [1, 1, 1],
};

export const defaultBaseEnhance: IBaseEnhance = {
    light: {
        // 智能亮度 [-100, 100], 浮点型
        smartLightAlpha: 0,
        // 亮度alpha [-100, 100], 浮点型
        brightness: 0,
        // 对比度alpha [-100, 100], 浮点型
        contrast: 0,
    },
    color: {
        // 饱和度alpha [-100, 100], 浮点型
        saturation: 0,
    },
    particulars: {
        // 锐化alpha[0, 100], 浮点型
        sharpen: 0,
        // 清晰度alpha[-100, 100], 浮点型
        structure: 0,
    },
};

export const defaultColorEnhance: IColorEnhance = {
    color: {
        // 色温alpha [-100, 100], 浮点型
        temperature: 0,
        // 色调alpha [-100, 100], 浮点型
        tinge: 0,
    },
};

export const defaultLightEnhance: ILightEnhance = {
    light: {
        // 高光alpha [-100, 100], 浮点型
        highlight: 0,
        // 暗部alpha [-100, 100], 浮点型
        shadow: 0,
        // 褪色alpha [0, 100], 浮点型
        fade: 0,
    },
};

export const defaultParticularsEnhance: IParticularsEnhance = {
    particulars: {
        // 颗粒alpha[0, 100], 浮点型
        particle: 0,
        // 色散alpha[0, 100], 浮点型
        dispersion: 0,
        // 暗角alpha[-100, 100], 浮点型
        vignette: 0,
    },
};

export const defaultPosterizeEnhance: IPosterizeEnhance = {
    // preHistoryTabIndex: 1,
    renderTabIndex: 1,
    color: {
        // 色调分离（高光）颜色[0, 100], 浮点型
        posterize_light: [0, 0, 0, 0, 0, 0],
        // 色调分离（高光）颜色 color:0,1,2,3,4,5
        posterize_light_color: 0,
        // 色调分离（阴影）颜色[0, 100], 浮点型
        posterize_shadow: [0, 0, 0, 0, 0, 0], // [0, 100], 浮点型
        // 色调分离（阴影）颜色 color:0,1,2,3,4,5
        posterize_shadow_color: 0,
    },
};

export const defaultHslEnhance: IHslEnhance = {
    selectIndex: 0,
    hsl: {
        hsl_hue: [0, 0, 0, 0, 0, 0],
        hsl_saturation: [0, 0, 0, 0, 0, 0],
        hsl_light: [0, 0, 0, 0, 0, 0],
        pickColors: '',
    },
};

export const defaultEnhanceParams = {
    baseEnhance: defaultBaseEnhance,
    colorEnhance: defaultColorEnhance,
    lightEnhance: defaultLightEnhance,
    particularsEnhance: defaultParticularsEnhance,
    posterizeEnhance: defaultPosterizeEnhance,
    hslEnhance: defaultHslEnhance,
};
